<style>
</style>
<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="icon/findIconCarCircleList.action"
                        ref="Table">
            <template slot="search">
                <el-row :gutter="10">
                    <el-col :span="4">
                        <el-button style="margin-left:10px;margin-bottom: 10px"  type="primary" @click="$router.push({path:'/home/saveCarCircleDialog'})">新增分类</el-button>
                    </el-col>
                </el-row>

            </template>
            <template slot="item">
                <el-table-column label="icon图">
                    <template scope="scope">
                        <img  style="width: 83px;height: 83px;" :src="scope.row.img" class="basic-margin" />
                    </template>
                </el-table-column>

                <el-table-column label="icon名称">
                    <template scope="scope">
                        <span >{{scope.row.name}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="排序值">
                    <template scope="scope">
                        <span>{{scope.row.sort}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="状态" width="300">
                    <template scope="scope">
                        <el-switch
                                @change='changeCarCircleStatus(scope.row.id,scope.row.status)'
                                v-model="scope.row.statusResult"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="250">
                    <template scope="scope">

                        <el-button type="danger"  size="small" @click="deleteCarCircle(scope.row.id)">删除</el-button>
                        <el-button type="warning"  size="small"  @click="$router.push({name:'编辑车友圈', params: { id: scope.row.id }})">编辑</el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import IconModel from '@/framework/models/iconModel'

export default {
  name: 'car-circle-management',
  components: {
    TableTemplate
  },
  extends: BasicPager,
  data: function () {
    return {
      queryParams: {
        channelId: null
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.queryParams.channelId = userInfo.id
  },
  methods: {

    search: function () {
      this.$refs.Table.search()
    },
    changeCarCircleStatus: function (id, status) {
      let _this = this
      let params = {
        id: id,
        status: status === 1 ? 2 : 1
      }
      let listener = {
        success: function (dataInfo) {
          _this.$refs.Table.search()
          _this.$message({
            type: 'success',
            message: '状态修改成功'
          })
        }
      }
      IconModel.changeCarCircleStatus(this, params, listener)
    },
    deleteCarCircle: function (id) {
      let _this = this
      this.$confirm('您是否要删除该图标?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let params = {
          id: id
        }
        let listener = {
          success: function (dataInfo) {
            _this.$refs.Table.search()
            _this.$message({
              type: 'success',
              message: '删除成功'
            })
          }
        }
        IconModel.deleteCarCircle(this, params, listener)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  },
  filters: {}
}
</script>

<style scoped>
</style>
